module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-list-box-2-wrap"
  }, [_c('div', {
    staticClass: "line-1"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.data_change
    },
    model: {
      value: (_vm.check_data),
      callback: function($$v) {
        _vm.check_data = $$v
      },
      expression: "check_data"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.box_data.right_id
    }
  }, [_vm._v(_vm._s(_vm.box_data.label))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f41f288a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authList/authList_box_1.vue
// module id = 1149
// module chunks = 1